var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.openModal
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "modal fade show",
            staticStyle: { display: "block" },
            attrs: {
              id: "go-modal-agent-alert",
              tabindex: "-1",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog go-modal-plan" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          return _vm.no()
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-block-header" }, [
                    _c("div", { staticClass: "go-msg-icon" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-text" }, [
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("briefing.popup.outOfActive.title", {
                                numCount: _vm.numCount,
                              })
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-block-body" }, [
                    _c("span", { staticClass: "go-text-sub" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("briefing.popup.outOfActive.sub")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.getSpecificRoleUser() !== "Ultra"
                      ? _c("div", { staticClass: "bg-gray" }, [
                          _c("div", { staticClass: "go-msg-text" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "briefing.popup.outOfActive.description",
                                    { plan: _vm.plan }
                                  )
                                ) + "\n                  "
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: { color: "#fd7e14" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.routeToPricingPlan()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "briefing.popup.outOfActive.upgrade"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("div", { staticClass: "go-block-between" }, [
                    _c("button", {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      domProps: {
                        textContent: _vm._s(_vm.$t("entity.action.cancel")),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.no()
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-backdrop fade show" }),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap fail" }, [
      _c("i", { staticClass: "go-icon-54 go-icon-alert-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }